/**
 * ROT13 Tool
 *
 * ROT13 cipher — encode and decode are the same operation (symmetric).
 */

import { SEMANTIC_TYPES } from '@/detectors/semanticTypes';
import type { ITransformerTool } from '@/interfaces/ITool';

export const Rot13Tool: ITransformerTool = {
  id: 'rot13',
  name: 'ROT13',
  description: 'ROT13 cipher — encode and decode text (same operation both ways)',
  version: '1.0.0',
  type: 'transformer',
  category: 'Encoders & Decoders',
  keywords: ['rot13', 'cipher', 'encode', 'decode', 'caesar', 'rotate'],

  seo: {
    slug: 'rot13-cipher',
    pageTitle: 'ROT13 Cipher - Free Online Tool | Prism',
    metaDescription: 'Apply ROT13 cipher to encode or decode text. Rotates each letter by 13 positions. Fast, private, runs entirely in your browser.',
    keywords: ['rot13', 'rot13 cipher', 'rot13 encoder', 'rot13 decoder', 'caesar cipher 13', 'rotate letters'],
    relatedTools: ['base64-encode', 'hex-encode', 'morse-code'],
    schemaType: 'WebApplication',
  },

  supportedInputTypes: [SEMANTIC_TYPES.TEXT],
  outputType: SEMANTIC_TYPES.TEXT,

  attributes: [],

  async transform(input: string): Promise<string> {
    const text = String(input ?? '');
    if (!text) return '';

    return text.replace(/[a-zA-Z]/g, (char) => {
      const base = char <= 'Z' ? 65 : 97;
      return String.fromCharCode(((char.charCodeAt(0) - base + 13) % 26) + base);
    });
  },
};
